var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z",
    fill: "#E2E8F0",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 58H38V30H66M66 26H38C36.9391 26 35.9217 26.4214 35.1716 27.1716C34.4214 27.9217 34 28.9391 34 30V58C34 59.0609 34.4214 60.0783 35.1716 60.8284C35.9217 61.5786 36.9391 62 38 62H66C67.0609 62 68.0783 61.5786 68.8284 60.8284C69.5786 60.0783 70 59.0609 70 58V30C70 28.9391 69.5786 27.9217 68.8284 27.1716C68.0783 26.4214 67.0609 26 66 26ZM30 34H26V66C26 67.0609 26.4214 68.0783 27.1716 68.8284C27.9217 69.5786 28.9391 70 30 70H62V66H30M55.92 44.58L50.42 51.66L46.5 46.94L41 54H63L55.92 44.58Z",
    fill: "#90A1B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImgIcon);
export default __webpack_public_path__ + "static/media/no-img-icon.3d93cd72339491adc7a2b43ba42a9392.svg";
export { ForwardRef as ReactComponent };